import React, { useMemo } from 'react';
import { tastics } from 'frontastic/tastics';
import { TasticWrapperProps } from './types';
import { injectDataSources } from '../../utils/inject-datasources';
import MissingTastic from '../missing-tastic';

/**
 * Full-screen tastics that don't need page-width constraints
 * Moved outside component to avoid recreating on each render
 */
const FULL_SCREEN_TASTICS = new Set([
  'commercetools/ui/footer',
  'commercetools/ui/header',
  'sol/ui/checkout-header',
  'sol/ui/checkout-footer',
]);

const TasticWrapper = React.memo(
  ({ data, params, searchParams, dataSources, isHighlighted, categories }: TasticWrapperProps) => {
    const Tastic = tastics[data.tasticType];

    // Memoize data resolution to avoid unnecessary injectDataSources calls
    const resolvedTasticData = useMemo(
      () => (dataSources ? injectDataSources(data.configuration, dataSources) : data.configuration),
      [data.configuration, dataSources],
    );

    // Use Set for faster lookup
    const isFullScreen = FULL_SCREEN_TASTICS.has(data?.tasticType);

    return (
      <div id={data?.tasticId} className={isFullScreen ? '' : 'px-4 lg:mx-auto lg:max-w-[--page-max-width]'}>
        {Tastic ? (
          <Tastic data={resolvedTasticData} params={params} searchParams={searchParams} categories={categories} />
        ) : (
          <MissingTastic data={data} />
        )}
      </div>
    );
  },
);

TasticWrapper.displayName = 'TasticWrapper';

export default TasticWrapper;